import script from "./Redirect.vue?vue&type=script&setup=true&lang=js"
export * from "./Redirect.vue?vue&type=script&setup=true&lang=js"

import "./Redirect.vue?vue&type=style&index=0&id=562dfd94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562dfd94"]])

export default __exports__